export default "<p>\n  viewordervendor works!\n</p>\n"